<template>
  <div class="box box-primary">
    <div class="overlay" v-if="occupe">
      <i class="fa fa-refresh fa-spin"></i>
      <div class="texte-occupe" v-if="progression">{{ progression }}</div>
    </div>

    <div class="box-header with-border">
      <h3 class="box-title">
        Facturation
        <small class="text-muted" v-if="factures.length">
          {{ factures.length }} facture(s) · {{ fm(totalDuLot) }}
          <span v-if="enregistrees" class="text-green">· enregistrées</span>
          <span v-else class="text-red">· non enregistrées</span>
        </small>
      </h3>
    </div>

    <div class="box-body">
      <p v-if="!factures.length" class="text-muted">
        <span v-if="!inscriptionsFacturables.length">
          Aucun inscrit facturable : les participants doivent être rattachés à une fiche membre.
        </span>
        <span v-else>Préparation des factures...</span>
      </p>

      <div v-if="montantsDivergents.length && !enregistrees" class="alert alert-warning alerte-divergence">
        <i class="fa fa-warning"></i>
        {{ montantsDivergents.length }} montant(s) ont changé dans les inscriptions depuis la
        préparation de ce lot.
        <a href="#" @click.prevent="preparer()">Reprendre les montants encodés</a>
      </div>

      <div class="row" v-if="factures.length">
        <div class="col-md-7">
        <div class="row ligne-commune" v-if="!enregistrees">
          <div class="col-md-5">
            <input type="text" class="form-control input-sm"
                   v-model="ligneCommune.description"
                   placeholder="Ajouter une ligne à toutes les factures (ex. frais de dossier)">
          </div>
          <div class="col-md-2">
            <div class="input-group input-group-sm">
              <input type="text" class="form-control text-right" v-model="ligneCommune.prixUnitaire">
              <span class="input-group-addon">€</span>
            </div>
          </div>
          <div class="col-md-5">
            <button type="button" class="btn btn-default btn-sm"
                    :disabled="!ligneCommune.description"
                    @click="ajouterLigneATous()">
              <i class="fa fa-plus"></i> Ajouter à tous
            </button>
            <button type="button" class="btn btn-default btn-sm pull-right" @click="reconstruire()">
              <i class="fa fa-refresh"></i> Repartir des inscriptions
            </button>
          </div>
        </div>

        <div class="row ligne-commune">
          <div class="col-md-7" v-if="renumerotables.length">
            <div class="input-group input-group-sm">
              <span class="input-group-addon">Numéroter à partir de</span>
              <input type="text" class="form-control" v-model="numeroDepart"
                     :placeholder="exempleNumero + ' ou simplement 42'"
                     @keyup.enter="renumeroterLot()">
            </div>
          </div>
          <div class="col-md-5" v-if="renumerotables.length">
            <button type="button" class="btn btn-default btn-sm"
                    :disabled="!departNormalise"
                    :title="departNormalise
                      ? 'Renumérote les ' + renumerotables.length + ' factures à la suite'
                      : 'Indiquez un rang de départ'"
                    @click="renumeroterLot()">
              <i class="fa fa-list-ol"></i> Renuméroter les {{ renumerotables.length }} factures
            </button>
            <span class="aide-numero" v-if="departNormalise && renumerotables.length">
              {{ departNormalise }} → {{ dernierNumeroPrevu }}
            </span>
          </div>
          <div class="col-md-12" v-if="dejaEnvoyees.length">
            <span class="aide-numero">
              <i class="fa fa-lock"></i>
              {{ dejaEnvoyees.length }} facture(s) déjà envoyée(s) gardent leur numéro : le
              destinataire paierait avec l'ancienne communication structurée.
            </span>
          </div>
        </div>

        <div v-if="alertesNumeros.length" class="alert alert-warning alerte-numeros">
          <i class="fa fa-warning"></i>
          <span v-for="(alerte, rang) in alertesNumeros" :key="rang" class="alerte-numero">
            {{ alerte }}
          </span>
          <div class="petite-alerte">
            Le serveur attribue d'office un autre numéro à ce qu'il refuse, et vous le dira
            après l'enregistrement.
          </div>
        </div>

        <table class="table table-condensed table-factures">
          <thead>
            <tr>
              <th class="colonne-case" v-if="enregistrees">
                <input type="checkbox" :checked="toutCoche" @change="basculerTout()">
              </th>
              <th>Participant</th>
              <th>Lignes</th>
              <th class="text-right colonne-total">Total</th>
              <th v-if="enregistrees" class="colonne-statut">Envoi</th>
              <th class="colonne-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(facture, index) in factures" :key="facture.id"
                :class="{'ligne-active': index === indexApercu}">
              <td class="colonne-case" v-if="enregistrees">
                <input type="checkbox"
                       :disabled="!facture.client.email"
                       :checked="!!selection[facture.idServeur]"
                       @change="basculer(facture)">
              </td>
              <td class="colonne-participant">
                <strong>{{ facture.client.nom }}</strong>
                <input v-if="numeroModifiable(facture)" type="text"
                       class="form-control input-sm champ-numero"
                       :class="{'numero-refuse': !numeroAccepte(facture.numero),
                                'numero-double': estEnDoublon(facture.numero),
                                'numero-en-attente': numeroEnAttente(facture)}"
                       :value="facture.numero"
                       :title="titreNumero(facture)"
                       @change="changerNumero(index, $event.target.value)">
                <div v-else class="numero-facture" :title="titreNumero(facture)">
                  <i class="fa fa-lock"></i> {{ facture.numero }}
                </div>
                <div v-if="!facture.client.email" class="text-red petite-alerte">
                  <i class="fa fa-warning"></i> Pas d'e-mail
                </div>
              </td>
              <td>
                <div v-if="enregistrees" class="lignes-lecture">
                  <div v-for="ligne in facture.lignes" :key="ligne.id" class="ligne-lecture">
                    <span class="texte-description">{{ ligne.description }}</span>
                    <span class="texte-prix">{{ fm(ligne.prixUnitaire) }}</span>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(ligne, rang) in facture.lignes" :key="ligne.id" class="ligne-editable">
                    <input type="text" class="form-control input-sm champ-description"
                           :value="ligne.description"
                           @input="modifierLigne(index, rang, 'description', $event.target.value)">
                    <div class="input-group input-group-sm champ-prix">
                      <input type="text" class="form-control text-right"
                             :value="ligne.prixUnitaire"
                             @input="modifierLigne(index, rang, 'prixUnitaire', $event.target.value)">
                      <span class="input-group-addon">€</span>
                    </div>
                    <button type="button" class="btn btn-default btn-xs bouton-retirer"
                            title="Retirer cette ligne"
                            :disabled="facture.lignes.length === 1"
                            @click="retirerLigne(index, rang)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </td>
              <td class="text-right colonne-total">{{ fm(totaux[index].total) }}</td>
              <td v-if="enregistrees" class="colonne-statut">
                <span :class="etat(facture).classe" :title="etat(facture).titre">
                  <i class="fa" :class="etat(facture).icone" v-if="etat(facture).icone"></i>
                  {{ etat(facture).libelle }}
                  <div class="petite-alerte" v-if="etat(facture).detail">
                    {{ etat(facture).detail.slice(0, 40) }}
                  </div>
                </span>
              </td>
              <td class="colonne-actions">
                <button type="button" class="btn btn-default btn-xs" title="Aperçu"
                        @click="ouvrirApercu(index)">
                  <i class="fa fa-eye"></i>
                </button>
                <button type="button" class="btn btn-danger btn-xs" title="Retirer cette facture"
                        @click="retirerFacture(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="col-md-5">
          <div class="panneau-apercu">
            <div v-if="!factureApercue" class="apercu-vide text-muted">
              <i class="fa fa-eye"></i>
              Cliquez sur l'œil d'une ligne pour relire la facture ici.
            </div>
            <div v-else>
              <div class="entete-apercu">
                <strong>{{ factureApercue.numero || 'Brouillon' }}</strong>
                — {{ factureApercue.client.nom }}
                <span class="pull-right">
                  <button type="button" class="btn btn-default btn-xs"
                          :disabled="indexApercu <= 0" title="Facture précédente"
                          @click="deplacerApercu(-1)">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <button type="button" class="btn btn-default btn-xs"
                          :disabled="indexApercu >= factures.length - 1" title="Facture suivante"
                          @click="deplacerApercu(1)">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                  <button type="button" class="btn btn-default btn-xs" title="Fermer l'aperçu"
                          @click="indexApercu = -1">
                    <i class="fa fa-times"></i>
                  </button>
                </span>
              </div>
              <facture-apercu :facture="factureApercue"
                              :totaux="totauxApercus"
                              :logo-data-url="logoDataUrl">
              </facture-apercu>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer" v-if="factures.length">
      <button type="button" class="btn btn-primary" :disabled="occupe" @click="exporterLot()">
        <i class="fa fa-download"></i> Exporter en un PDF
      </button>
      <button type="button" class="btn btn-default" :disabled="occupe || enregistrees"
              @click="enregistrerLot()">
        <i class="fa fa-save"></i> Enregistrer le lot
      </button>
      <button type="button" class="btn btn-success" v-if="enregistrees"
              :disabled="occupe || !nombreSelectionne"
              data-toggle="modal" data-target="#modalEnvoiFactures">
        <i class="fa fa-paper-plane"></i> Envoyer ({{ nombreSelectionne }})
      </button>
      <button type="button" class="btn btn-warning"
              v-if="enregistrees && renumerotationsEnAttente.length"
              :disabled="occupe" @click="appliquerRenumerotation()">
        <i class="fa fa-list-ol"></i>
        Appliquer la renumérotation ({{ renumerotationsEnAttente.length }})
      </button>
      <button type="button" class="btn btn-default pull-right" v-if="enregistrees"
              :disabled="occupe" @click="rafraichir()">
        <i class="fa fa-refresh"></i> Actualiser les statuts
      </button>
    </div>

    <!-- Envoi en masse -->
    <div class="modal fade" tabindex="-1" role="dialog" id="modalEnvoiFactures">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            <h4 class="modal-title">Envoyer {{ nombreSelectionne }} facture(s)</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Objet</label>
              <input type="text" class="form-control" v-model="envoi.sujet">
            </div>
            <div class="form-group">
              <label>Message</label>
              <textarea class="form-control" rows="6" v-model="envoi.message"></textarea>
              <span class="help-block">
                <code>{numero}</code>, <code>{prenom}</code> et <code>{nom}</code> sont remplacés
                pour chaque destinataire.
              </span>
            </div>
            <div class="form-group">
              <label>Copie (facultatif)</label>
              <input type="text" class="form-control" v-model="envoi.copie"
                     placeholder="secretariat@abft.be">
              <span class="help-block">
                Une adresse <code>@abft.be</code> uniquement : la facture est en
                pièce jointe, elle ne sort pas de la fédération.
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
            <button type="button" class="btn btn-success" @click="envoyerSelection()">
              <i class="fa fa-paper-plane"></i> Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import FactureApercu from '../../Outils/Facture/FactureApercu'
  import {facturesDepuisFormation} from '../../../utils/facture/formation'
  import {calculerTotaux, formaterMontant, normaliserMontant} from '../../../utils/facture/calculs'
  import {ligneVierge} from '../../../utils/facture/modele'
  import {prochainNumero, communicationStructuree, numeroAcceptableParServeur,
    normaliserNumeroSaisi, sequenceNumeros, doublonsDansLot,
    formatLisible} from '../../../utils/facture/numerotation'
  import {chargerLogoFederation} from '../../../utils/facture/federation'
  import {telechargerLotFacturesPdf, factureEnBase64} from '../../../utils/facture/pdf'
  import {dernierEnvoi, etatEnvoi, detailPlafond} from '../../../utils/facture/envois'
  import * as depot from '../../../utils/facture/depot'

  export default {
    name: 'FacturationFormation',
    components: {FactureApercu},
    props: {
      formation: {type: Object, default: null}
    },
    data () {
      return {
        factures: [],
        enregistrees: false,
        selection: {},
        ligneCommune: {description: '', prixUnitaire: ''},
        numeroDepart: '',
        formatNumero: formatLisible(),
        // Numéros tels que le serveur les porte : l'écart avec facture.numero
        // est ce qui reste à lui envoyer.
        numerosServeur: {},
        envoi: {sujet: 'Votre facture ABFT {numero}', message: '', copie: ''},
        minuteurRelecture: null,
        indexApercu: -1,
        logoDataUrl: null,
        occupe: false,
        progression: ''
      }
    },
    computed: {
      inscriptionsFacturables () {
        const inscriptions = (this.formation && this.formation.inscriptions) || []
        return inscriptions.filter(function (inscription) { return inscription.membre })
      },
      totaux () {
        return this.factures.map(calculerTotaux)
      },
      totalDuLot () {
        return this.totaux.reduce(function (somme, totaux) { return somme + totaux.total }, 0)
      },
      /**
       * Le montant d'une inscription peut être complété après coup (bouton
       * d'application en masse dans « Inscriptions et résultats »). Sans ce
       * repère, le lot resterait silencieusement à l'ancien montant.
       */
      montantsDivergents () {
        const inscriptions = (this.formation && this.formation.inscriptions) || []
        const parId = {}
        inscriptions.forEach(function (inscription) { parId[inscription.id] = inscription })

        return this.factures.filter(function (facture) {
          const origine = facture.origine || {}
          const inscription = parId[origine.idInscription]
          if (!inscription || !facture.lignes.length) return false
          return normaliserMontant(facture.lignes[0].prixUnitaire) !==
            normaliserMontant(inscription.montant)
        })
      },
      anneeCourante () {
        return new Date().getFullYear()
      },
      /** Un exemple au format en vigueur vaut mieux qu'un gabarit abstrait. */
      exempleNumero () {
        return this.formatNumero
          .replace('AAAA', String(this.anneeCourante))
          .replace(/N+/, function (rang) {
            let exemple = '42'
            while (exemple.length < rang.length) exemple = '0' + exemple
            return exemple
          })
      },
      departNormalise () {
        return normaliserNumeroSaisi(this.numeroDepart, this.anneeCourante)
      },
      /** Ce que donnerait la renumérotation : montrer la fin évite la surprise. */
      dernierNumeroPrevu () {
        const sequence = sequenceNumeros(this.departNormalise, this.renumerotables.length)
        return sequence.length ? sequence[sequence.length - 1] : ''
      },
      /** Une facture partie ne change plus de numéro : le serveur refuserait. */
      renumerotables () {
        if (!this.enregistrees) return this.factures
        return this.factures.filter(function (facture) {
          return !dernierEnvoi(facture)
        })
      },
      dejaEnvoyees () {
        if (!this.enregistrees) return []
        return this.factures.filter(function (facture) {
          return !!dernierEnvoi(facture)
        })
      },
      renumerotationsEnAttente () {
        if (!this.enregistrees) return []
        const composant = this
        return this.renumerotables.filter(function (facture) {
          return composant.numeroEnAttente(facture)
        })
      },
      numerosDoubles () {
        return doublonsDansLot(this.factures.map(function (f) { return f.numero }))
      },
      numerosRefuses () {
        return this.factures
          .map(function (f) { return f.numero })
          .filter(function (numero) { return numero && !numeroAcceptableParServeur(numero) })
      },
      /**
       * Ce que le serveur refuserait en l'état. Il arbitrerait de toute façon,
       * mais une facture renumérotée en silence est une facture qu'on cherche.
       */
      alertesNumeros () {
        if (this.enregistrees) return []
        const alertes = []
        if (this.numerosDoubles.length) {
          alertes.push(this.numerosDoubles.length + ' numéro(s) en double dans le lot : ' +
            this.numerosDoubles.join(', ') + '.')
        }
        if (this.numerosRefuses.length) {
          alertes.push(this.numerosRefuses.length + ' numéro(s) hors du format ' +
            this.formatNumero + ' : ' +
            this.numerosRefuses.slice(0, 3).join(', ') + '.')
        }
        return alertes
      },
      selectionnables () {
        return this.factures.filter(function (facture) {
          return facture.idServeur && facture.client.email
        })
      },
      nombreSelectionne () {
        const selection = this.selection
        return this.selectionnables.filter(function (f) { return selection[f.idServeur] }).length
      },
      toutCoche () {
        return this.selectionnables.length > 0 &&
          this.nombreSelectionne === this.selectionnables.length
      },
      factureApercue () {
        return this.indexApercu >= 0 ? this.factures[this.indexApercu] : null
      },
      totauxApercus () {
        return this.factureApercue ? calculerTotaux(this.factureApercue) : null
      }
    },
    watch: {
      formation: {
        immediate: true,
        handler () { this.charger() }
      }
    },
    mounted () {
      const composant = this
      chargerLogoFederation().then(function (dataUrl) { composant.logoDataUrl = dataUrl })
      // Le préfixe n'est plus figé : sans ça, tout le lot serait proposé au
      // mauvais format puis renuméroté en silence par le serveur.
      depot.chargerFormatNumerotation({forcer: true}).then(function () { composant.formatNumero = formatLisible() })
      this.envoi.message = 'Bonjour {prenom},\n\nVeuillez trouver ci-joint votre facture ' +
        '{numero}.\n\nCordialement,\nLe secrétariat ABFT'
    },
    beforeDestroy () {
      // Ne pas relire une liste dont l'onglet est déjà parti
      if (this.minuteurRelecture) clearTimeout(this.minuteurRelecture)
    },
    methods: {
      fm (valeur) {
        return formaterMontant(valeur, 'EUR')
      },

      /**
       * Les factures déjà émises font foi : on ne les reconstruit pas depuis
       * les inscriptions, sans quoi une facture envoyée changerait sous les
       * pieds de son destinataire.
       */
      charger () {
        if (!this.formation) {
          this.factures = []
          return
        }
        const composant = this
        this.occupe = true
        depot.listerFactures({origineType: 'formation', origineId: this.formation.id}).then(
          function (factures) {
            composant.occupe = false
            if (factures.length) {
              composant.factures = factures
              composant.enregistrees = true
              composant.memoriserNumerosServeur(factures)
              composant.toutSelectionner(true)
            } else {
              composant.preparer()
            }
          },
          function () {
            composant.occupe = false
            composant.$noty.error('Factures existantes illisibles, préparation d\'un nouveau lot')
            composant.preparer()
          })
      },

      /** Prépare un lot à partir des inscriptions, sans rien enregistrer. */
      preparer () {
        // Numéros provisoires : le serveur tranchera à l'enregistrement
        let compteurs = {}
        const annee = new Date().getFullYear()
        const numeroter = function () {
          const resultat = prochainNumero(compteurs, annee)
          compteurs = resultat.compteurs
          return resultat.numero
        }

        const factures = facturesDepuisFormation(this.formation, this.inscriptionsFacturables,
          {numeroter: numeroter})
        factures.forEach(function (facture) {
          facture.paiement.communicationStructuree = communicationStructuree(facture.numero)
        })
        this.factures = factures
        this.enregistrees = false
        this.selection = {}
        this.indexApercu = -1
        this.numeroDepart = factures.length ? factures[0].numero : ''
      },

      reconstruire () {
        if (!confirm('Reconstruire les factures depuis les inscriptions ? Les retouches seront perdues.')) return
        this.preparer()
      },

      rafraichir () {
        this.charger()
      },

      /** Relecture unique ~15 s après un envoi, le temps que Mailgun réponde. */
      relireApresEnvoi () {
        const composant = this
        if (this.minuteurRelecture) clearTimeout(this.minuteurRelecture)
        this.minuteurRelecture = setTimeout(function () {
          composant.minuteurRelecture = null
          if (composant.enregistrees && !composant.occupe) composant.charger()
        }, 15000)
      },

      numeroAccepte (numero) {
        return numeroAcceptableParServeur(numero)
      },

      estEnDoublon (numero) {
        return this.numerosDoubles.indexOf(String(numero || '').trim()) !== -1
      },

      /** Une facture partie garde son numéro : le serveur refuserait (409). */
      numeroModifiable (facture) {
        return !this.enregistrees || !dernierEnvoi(facture)
      },

      numeroEnAttente (facture) {
        if (!facture.idServeur) return false
        return this.numerosServeur[facture.idServeur] !== undefined &&
          this.numerosServeur[facture.idServeur] !== facture.numero
      },

      titreNumero (facture) {
        if (this.enregistrees && !this.numeroModifiable(facture)) {
          return 'Facture déjà envoyée : son numéro ne peut plus changer. La communication ' +
            'structurée en dérive, et le destinataire paierait avec l’ancienne.'
        }
        if (this.estEnDoublon(facture.numero)) {
          return 'Ce numéro est déjà porté par une autre facture du lot.'
        }
        if (!this.numeroAccepte(facture.numero)) {
          return 'Format attendu : ' + this.formatNumero +
            (this.enregistrees ? '. Le serveur refusera celui-ci.'
              : '. Le serveur remplacera celui-ci.')
        }
        if (this.numeroEnAttente(facture)) {
          return 'Modifié : reste à appliquer. Le serveur porte encore ' +
            this.numerosServeur[facture.idServeur] + '.'
        }
        return this.enregistrees
          ? 'Numéro en vigueur sur le serveur.'
          : 'Numéro proposé au serveur. Il le garde s’il est encore libre.'
      },

      /** Mémorise ce que le serveur porte, pour mesurer l'écart ensuite. */
      memoriserNumerosServeur (factures) {
        const carte = {}
        ;(factures || []).forEach(function (facture) {
          if (facture.idServeur) carte[facture.idServeur] = facture.numero
        })
        this.numerosServeur = carte
      },

      /**
       * Envoie les numéros modifiés, documents régénérés compris : la colonne
       * et le PDF conservé ne doivent jamais se contredire.
       */
      appliquerRenumerotation () {
        const composant = this
        const enAttente = this.renumerotationsEnAttente.slice()
        if (!enAttente.length) return

        this.occupe = true
        this.progression = 'Régénération des PDF...'

        enAttente.reduce(function (chaine, facture, index) {
          return chaine.then(function (entrees) {
            composant.progression = 'Régénération des PDF ' + (index + 1) + '/' + enAttente.length
            return factureEnBase64(facture, calculerTotaux(facture), null, composant.logoDataUrl)
              .then(function (base64) {
                entrees.push({facture: facture, numero: facture.numero, pdf: base64})
                return entrees
              })
          })
        }, Promise.resolve([])).then(function (entrees) {
          composant.progression = 'Renumérotation...'
          return depot.renumeroterLot(entrees)
        }).then(function (renumerotees) {
          composant.occupe = false
          composant.progression = ''
          composant.$noty.success(renumerotees.length + ' facture(s) renumérotée(s)')
          composant.charger()
        }, function (erreur) {
          composant.occupe = false
          composant.progression = ''
          composant.$noty.error(composant.messageRefus(erreur))
        })
      },

      /**
       * Le lot est refusé en entier dès qu'une ligne pose problème : dire
       * laquelle et pourquoi, sinon il ne reste qu'un « 422 » à interpréter.
       */
      messageRefus (erreur) {
        const corps = (erreur && erreur.data) || {}
        const refus = corps.refus
        if (!refus || !refus.length) {
          return this.messageErreur(erreur, 'Renumérotation impossible')
        }

        const composant = this
        const motifs = {
          envoyee: 'déjà envoyée',
          numero_pris: 'numéro déjà attribué',
          doublon_dans_le_lot: 'numéro en double dans le lot',
          hors_format: 'numéro hors format',
          introuvable: 'facture introuvable'
        }
        const details = refus.slice(0, 3).map(function (ligne) {
          const facture = composant.factures.filter(function (f) {
            return f.idServeur === ligne.id
          })[0]
          const qui = facture ? facture.client.nom : 'facture ' + ligne.id
          return qui + ' : ' + (motifs[ligne.motif] || ligne.motif)
        })
        return 'Renumérotation refusée en bloc — ' + details.join(' ; ') +
          (refus.length > 3 ? ' (et ' + (refus.length - 3) + ' autre(s))' : '')
      },



      /**
       * La communication structurée dérive du numéro : la recalculer tout de
       * suite, sinon le virement arriverait sous l’ancienne référence.
       */
      changerNumero (index, saisie) {
        const facture = this.factures[index]
        const numero = normaliserNumeroSaisi(saisie, this.anneeCourante) ||
          String(saisie || '').trim()
        facture.numero = numero
        facture.paiement.communicationStructuree = communicationStructuree(numero)
      },

      /** Renumérote tout le lot à la suite, depuis le rang saisi. */
      renumeroterLot () {
        const depart = this.departNormalise
        const concernees = this.renumerotables
        if (!depart || !concernees.length) return

        const numeros = sequenceNumeros(depart, concernees.length)
        concernees.forEach(function (facture, index) {
          facture.numero = numeros[index]
          facture.paiement.communicationStructuree = communicationStructuree(numeros[index])
        })
        this.$noty.success(concernees.length + ' facture(s) renumérotée(s)' +
          (this.enregistrees ? ' — reste à appliquer' : ''))
      },

      modifierLigne (indexFacture, rang, champ, valeur) {
        this.factures[indexFacture].lignes[rang][champ] = valeur
      },

      retirerLigne (indexFacture, rang) {
        this.factures[indexFacture].lignes.splice(rang, 1)
      },

      retirerFacture (index) {
        const facture = this.factures[index]
        if (!facture.idServeur) {
          this.factures.splice(index, 1)
          return
        }
        if (!confirm('Supprimer définitivement la facture ' + facture.numero + ' ?')) return

        const composant = this
        this.occupe = true
        depot.supprimerFacture(facture.idServeur).then(function () {
          composant.occupe = false
          composant.factures.splice(index, 1)
        }, function () {
          composant.occupe = false
          composant.$noty.error('Suppression impossible')
        })
      },

      ajouterLigneATous () {
        const description = this.ligneCommune.description
        const prix = normaliserMontant(this.ligneCommune.prixUnitaire)
        this.factures.forEach(function (facture) {
          facture.lignes.push(Object.assign(ligneVierge(), {
            description: description, quantite: 1, prixUnitaire: prix
          }))
        })
        this.ligneCommune = {description: '', prixUnitaire: ''}
      },

      basculer (facture) {
        this.$set(this.selection, facture.idServeur, !this.selection[facture.idServeur])
      },

      basculerTout () {
        this.toutSelectionner(!this.toutCoche)
      },

      toutSelectionner (actif) {
        const selection = {}
        this.selectionnables.forEach(function (facture) {
          selection[facture.idServeur] = actif
        })
        this.selection = selection
      },

      /** L'acheminement réel du dernier envoi : voir utils/facture/envois.js. */
      etat (facture) {
        return etatEnvoi(dernierEnvoi(facture))
      },

      ouvrirApercu (index) {
        // Un second clic sur la même ligne referme le panneau
        this.indexApercu = this.indexApercu === index ? -1 : index
      },

      deplacerApercu (pas) {
        const cible = this.indexApercu + pas
        if (cible >= 0 && cible < this.factures.length) this.indexApercu = cible
      },

      exporterLot () {
        const composant = this
        this.occupe = true
        telechargerLotFacturesPdf(this.factures, {
          intitule: this.formation ? this.formation.titre : '',
          logoDataUrl: this.logoDataUrl
        }).then(function () {
          composant.occupe = false
        }, function (erreur) {
          console.error('Erreur lors de l\'export groupé des factures:', erreur)
          composant.occupe = false
          composant.$noty.error('L\'export groupé a échoué')
        })
      },

      /** Chaque PDF est produit ici puis confié au serveur : c'est celui qui a été relu. */
      produirePdfs () {
        const composant = this
        const pdfs = {}
        return this.factures.reduce(function (chaine, facture, index) {
          return chaine.then(function () {
            composant.progression = 'Préparation des PDF ' + (index + 1) + '/' + composant.factures.length
            return factureEnBase64(facture, calculerTotaux(facture), null, composant.logoDataUrl)
              .then(function (base64) { pdfs[facture.id] = base64 })
          })
        }, Promise.resolve()).then(function () { return pdfs })
      },

      enregistrerLot () {
        const composant = this
        const proposes = this.factures.map(function (f) { return f.numero })
        this.occupe = true

        this.produirePdfs().then(function (pdfs) {
          composant.progression = 'Enregistrement...'
          return depot.enregistrerFactures(composant.factures, pdfs)
        }).then(function (enregistrees) {
          return composant.corrigerCommunications(enregistrees, proposes)
        }).then(function (enregistrees) {
          composant.occupe = false
          composant.progression = ''
          composant.factures = enregistrees
          composant.enregistrees = true
          composant.memoriserNumerosServeur(enregistrees)
          composant.toutSelectionner(true)
          composant.$noty.success(enregistrees.length + ' facture(s) enregistrée(s)')
        }, function (erreur) {
          console.error('Erreur lors de l\'enregistrement des factures:', erreur)
          composant.occupe = false
          composant.progression = ''
          composant.$noty.error(composant.messageErreur(erreur, 'Enregistrement impossible'))
        })
      },

      /**
       * Le serveur peut attribuer un autre numéro que celui proposé. La
       * communication structurée en dérive : sans cette reprise, le virement
       * porterait une référence qui ne correspond à aucune facture.
       */
      corrigerCommunications (enregistrees, proposes) {
        const aCorriger = enregistrees.filter(function (facture, index) {
          return facture.numero !== proposes[index]
        })
        if (!aCorriger.length) return Promise.resolve(enregistrees)

        const composant = this
        // Un numéro déjà pris ou hors format est remplacé par le serveur. Sans
        // ce message, le lot repartirait avec des numéros qu'on n'a pas choisis.
        composant.$noty.warning(aCorriger.length + ' numéro(s) étaient déjà pris ou hors ' +
          'format : le serveur en a attribué d\'autres.')
        composant.progression = 'Mise à jour des communications...'
        return aCorriger.reduce(function (chaine, facture) {
          facture.paiement.communicationStructuree = communicationStructuree(facture.numero)
          return chaine.then(function () { return depot.majFacture(facture) })
        }, Promise.resolve()).then(function () { return enregistrees })
      },

      /** Remonte le message du serveur quand il en donne un : un code seul n'aide personne. */
      messageErreur (erreur, defaut) {
        const corps = erreur && erreur.data
        const message = corps && (corps.message || corps.error)
        const plafond = detailPlafond(corps)
        if (!message) return defaut + ' (' + ((erreur && erreur.status) || '?') + ')'
        return defaut + ' : ' + String(message).slice(0, 180) + (plafond ? ' — ' + plafond : '')
      },

      envoyerSelection () {
        const composant = this
        const selection = this.selection
        const ids = this.selectionnables
          .filter(function (f) { return selection[f.idServeur] })
          .map(function (f) { return f.idServeur })

        $('#modalEnvoiFactures').modal('hide')
        this.occupe = true
        this.progression = 'Envoi en cours...'

        depot.envoyerFactures({
          ids: ids,
          sujet: this.envoi.sujet,
          message: this.envoi.message,
          copie: this.envoi.copie || null
        }).then(function (resultats) {
          composant.progression = ''
          const echecs = resultats.filter(function (r) { return r.statut && r.statut !== 'envoye' })
          if (echecs.length) {
            composant.$noty.error(echecs.length + ' envoi(s) en échec sur ' + resultats.length)
          } else {
            composant.$noty.success(resultats.length + ' facture(s) envoyée(s)')
          }
          composant.charger()
          // Mailgun confirme la remise en quelques secondes : une relecture
          // différée suffit, inutile d'interroger le serveur en boucle.
          composant.relireApresEnvoi()
        }, function (erreur) {
          composant.occupe = false
          composant.progression = ''
          composant.$noty.error(composant.messageErreur(erreur, 'L\'envoi a échoué'))
        })
      }
    }
  }
</script>

<style scoped>
  .ligne-commune {
    margin-bottom: 14px;
  }

  .alerte-divergence {
    margin-bottom: 14px;
  }

  .texte-occupe {
    margin-top: 8px;
    font-size: 12px;
    color: #555;
  }

  .table-factures > tbody > tr > td {
    vertical-align: top;
  }

  .colonne-case {
    width: 34px;
    text-align: center;
  }

  .colonne-participant {
    width: 210px;
  }

  .numero-facture {
    font-size: 11px;
    color: #777;
  }

  .petite-alerte {
    font-size: 11px;
  }

  .ligne-editable {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  /* `flex: 1 1 auto` sans `min-width: 0` laisserait le champ pousser la ligne
     au-delà de la colonne */
  .champ-description {
    flex: 1 1 auto;
    min-width: 0;
  }

  .champ-prix {
    flex: 0 0 118px;
    margin-left: 6px;
  }

  .bouton-retirer {
    flex: 0 0 auto;
    margin-left: 6px;
  }

  .ligne-lecture {
    display: flex;
    align-items: baseline;
    padding: 2px 0;
  }

  .texte-description {
    flex: 1 1 auto;
    min-width: 0;
  }

  .texte-prix {
    flex: 0 0 90px;
    text-align: right;
    color: #555;
  }

  .colonne-total {
    width: 110px;
    font-weight: 700;
  }

  .champ-numero {
    width: 140px;
    margin-top: 3px;
    padding: 2px 6px;
    height: 24px;
    font-size: 11px;
    font-family: monospace;
  }

  /* Ce que le serveur refuserait : signalé avant l'enregistrement, pas après */
  .numero-refuse {
    border-color: #f39c12;
    background: #fffaf0;
  }

  /* Modifié mais pas encore envoyé au serveur */
  .numero-en-attente {
    border-color: #f39c12;
    background: #fff8e8;
    font-weight: 700;
  }

  .numero-double {
    border-color: #dd4b39;
    background: #fff5f4;
  }

  .alerte-numeros {
    padding: 8px 12px;
    margin-bottom: 14px;
    font-size: 12px;
  }

  .alerte-numero {
    display: block;
  }

  .aide-numero {
    display: inline-block;
    margin-left: 10px;
    font-size: 11px;
    color: #777;
    line-height: 30px;
  }

  .colonne-statut {
    width: 155px;
    font-size: 12px;
  }

  /* Le motif d'échec est verbeux : on le laisse tenir sur deux lignes et le
     titre porte la version complète. */
  .colonne-statut .petite-alerte {
    line-height: 1.3;
    word-break: break-word;
  }

  .colonne-actions {
    width: 70px;
    white-space: nowrap;
    text-align: right;
  }

  /* L'aperçu reste visible pendant qu'on parcourt la liste */
  .panneau-apercu {
    position: sticky;
    top: 12px;
    background: #f4f4f4;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    padding: 10px;
  }

  .entete-apercu {
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 22px;
  }

  .apercu-vide {
    padding: 28px 12px;
    text-align: center;
    font-size: 12px;
  }

  .ligne-active {
    background: #f0f7fb;
    box-shadow: inset 3px 0 0 #3c8dbc;
  }
</style>



// WEBPACK FOOTER //
// src/components/Secretariat/Formation/FacturationFormation.vue